import { createAction, ActionsUnion } from 'app/shared/utils/action-helpers';

// Models
import { BlacklistActionTypes, Blacklist } from 'app/modules/lists/models';
import {
  CreateBlacklistPayload,
  RetrieveBlacklistsPayload,
} from 'app/modules/lists/requests';
import { RetrieveBlacklistsResponse } from 'app/modules/lists/responses';

export const retrieveBlacklists = (payload: RetrieveBlacklistsPayload) =>
  createAction(BlacklistActionTypes.RETRIEVE_BLACKLISTS, payload);

export const retrieveBlacklistsSuccess = (result: RetrieveBlacklistsResponse) =>
  createAction(BlacklistActionTypes.RETRIEVE_BLACKLISTS_SUCCESS, result);

export const createBlacklist = (payload: CreateBlacklistPayload) =>
  createAction(BlacklistActionTypes.CREATE_BLACKLIST, payload);

export const createBlacklistSuccess = (result: Blacklist) =>
  createAction(BlacklistActionTypes.CREATE_BLACKLIST_SUCCESS, result);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const BlacklistActionsList = {
  retrieveBlacklists,
  retrieveBlacklistsSuccess,
  createBlacklist,
  createBlacklistSuccess,
};

type BlacklistActions = ActionsUnion<typeof BlacklistActionsList>;

export default BlacklistActions;
